module.exports = __webpack_public_path__ + "img/naar-en-ven-2.eb85df42.png";